import { useId, type InputHTMLAttributes } from 'react'
import './componentes.css'

/**
 * Campo de formulário com rótulo associado, ajuda e erro em texto (A11Y-06).
 *
 * O erro é anunciado por `aria-describedby` e por `role="alert"`, e nunca é
 * comunicado só pela borda vermelha — cor não pode ser o único portador de
 * informação (UI-09), e quem não distingue vermelho não veria erro nenhum.
 */
export function Campo({
  rotulo,
  ajuda,
  erro,
  obrigatorio,
  ...resto
}: InputHTMLAttributes<HTMLInputElement> & {
  rotulo: string
  ajuda?: string
  erro?: string
  obrigatorio?: boolean
}) {
  const id = useId()
  const idAjuda = `${id}-ajuda`
  const idErro = `${id}-erro`

  const descritores = [ajuda ? idAjuda : null, erro ? idErro : null]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={`campo ${erro ? 'campo--erro' : ''}`}>
      <label className="campo__rotulo" htmlFor={id}>
        {rotulo}
        {obrigatorio && (
          <span className="campo__obrigatorio" aria-hidden="true">
            *
          </span>
        )}
      </label>

      <input
        id={id}
        className="campo__entrada"
        aria-invalid={erro ? true : undefined}
        aria-describedby={descritores || undefined}
        aria-required={obrigatorio || undefined}
        {...resto}
      />

      {ajuda && (
        <p className="campo__ajuda" id={idAjuda}>
          {ajuda}
        </p>
      )}
      {erro && (
        <p className="campo__mensagem-erro" id={idErro} role="alert">
          <span aria-hidden="true">! </span>
          {erro}
        </p>
      )}
    </div>
  )
}
